export default class Task {

    /**
     * Typically, Task subclasses are instantiated using a factory which will inject dependencies.
     */
    constructor() {
    }

    
    /**
     * @param {Function} callback - callback function, see WrappedTask.execute()
     * @param {Function} progressCallback - callback function, see WrappedTask.execute()
     */
    execute(callback, progressCallback) {
        //override!
    }

}